const sectionsToRender = [
  {
    id: '#CartDrawer-Body',
    section: 'cart-drawer',
    selector: '#shopify-section-cart-drawer #CartDrawer-Body',
  },
];

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close(),
    );
    this.querySelector('#CartDrawer-Overlay').addEventListener(
      'click',
      this.close.bind(this),
    );
    this.setCartLinks();
  }

  setCartLinks() {
    const cartLinks = document.querySelectorAll('[data-cart-link]');

    cartLinks.forEach((cartLink) => {
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink);
      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() !== 'SPACE') return;
        event.preventDefault();
        this.open(cartLink);
      });
    });
  }

  open(opener) {
    if (opener) this.setActiveElement(opener);
    this.classList.add('is-visible');
    this.addEventListener(
      'transitionend',
      () => {
        this.focusOnCartDrawer();
      },
      { once: true },
    );
    bodyScroll.lock(this.querySelector('#CartDrawer-Body'));

    // GA4 Ecommerce - View Cart Event (only when opened manually, not via renderContents)
    if (opener && typeof dataLayer !== 'undefined') {
      this.trackViewCart();
    }
  }

  close() {
    this.classList.remove('is-visible');
    removeTrapFocus(this.activeElement);
    bodyScroll.unlock(this.querySelector('#CartDrawer-Body'));
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  focusOnCartDrawer() {
    const containerToTrapFocusOn = this.querySelector('#CartDrawer');
    const focusElement = this.querySelector('[data-drawer-close]');
    trapFocus(containerToTrapFocusOn, focusElement);
  }

  /**
   * Call this before adding to cart (e.g. on product form submit) so that the
   * next renderContents() will open the drawer. Prevents third-party scripts
   * (e.g. FastBundle) from opening the drawer on page load.
   */
  setOpenAfterNextRender() {
    this._openAfterNextRender = true;
  }

  renderContents(response) {
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = document.querySelector(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        response.sections[section.section],
        section.selector,
      );
    });
    // Only open when the product form was submitted (flag set in global.js),
    // not when a third-party script (e.g. FastBundle) syncs the cart on load.
    if (this._openAfterNextRender) {
      this._openAfterNextRender = false;
      this.open();
    }
  }

  getSectionsToRender() {
    return [...Cart.getLiveRegions(), ...sectionsToRender];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  trackViewCart() {
    const cartDataElement = this.querySelector('[data-cart-ga4][type="application/json"]');
    if (!cartDataElement) {
      return;
    }

    try {
      const cartData = JSON.parse(cartDataElement.textContent);

      if (!cartData.items || cartData.items.length === 0) {
        return;
      }

      const items = cartData.items.map((item) => {
        const itemName = item.variant_title && item.variant_title !== 'Default Title'
          ? `${item.product_title} - ${item.variant_title}`
          : item.product_title;
        const itemId = `shopify_${item.product_id}_${item.variant_id}`;

        return {
          'item_name': itemName,
          'item_id': itemId,
          'item_brand': item.product_vendor,
          'item_category': item.product_type,
          'currency': cartData.currency_code,
          'price': item.price,
          'quantity': item.quantity
        };
      });

      dataLayer.push({ 'ecommerce': null });  // Clear the previous ecommerce object

      dataLayer.push({
        'event': 'view_cart',
        'ecommerce': {
          'currency': cartData.currency_code,
          'value': cartData.total_price,
          'items': items
        }
      });
    } catch (error) {
      console.error('GA4 View Cart: Error parsing cart data', error);
    }
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [...Cart.getLiveRegions(), ...sectionsToRender];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
